<span [ngSwitch]="value">
  <span class="badge bg-primary" *ngSwitchCase="leadStatusEnum.NEW">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge lead-status-unreachable" *ngSwitchCase="leadStatusEnum.UNREACHABLE">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-info text-dark" *ngSwitchCase="leadStatusEnum.REACHED">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-danger" *ngSwitchCase="leadStatusEnum.NOT_RELEVANT">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge lead-status-interested" *ngSwitchCase="leadStatusEnum.INTERESTED">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-warning text-dark" *ngSwitchCase="leadStatusEnum.PRICE_SENSITIVE">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge lead-status-competitor" *ngSwitchCase="leadStatusEnum.CHOSE_COMPETITOR">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-success" *ngSwitchCase="leadStatusEnum.CONVERTED">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-dark" *ngSwitchCase="leadStatusEnum.LOST">
    {{ 'leadStatusValue.' + value | translate }}
  </span>

  <span class="badge bg-secondary" *ngSwitchDefault>
    {{ value ? ('leadStatusValue.' + value | translate) : '-' }}
  </span>
</span>